
import React, { useState, useContext, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import Icon from '@material-ui/core/Icon';
import PropTypes from 'prop-types';
import axios from "axios";
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
import TablePagination from '@material-ui/core/TablePagination';

import RemoteTable from 'App/components/RemoteTable';
import { Estado } from 'App/Helpers/Iconos';
import { LayoutContext } from 'App/Layout/store';
import _ from 'underscore';
import ModalDTEs from '../components/ModalDTEs';
import AddCircle from '@material-ui/icons/AddCircle';

const YellowBadge = withStyles(theme => ({
    badge: {
        fontSize: 8,
        backgroundColor: 'yellow'
    },
}))(Badge);
const StyledBadge = withStyles(theme => ({
    badge: {
        fontSize: 8
    },
}))(Badge);

const styles = theme => ({
    root: {
        width: "100%",
        marginTop: theme.spacing.unit * 3
    },
    table: {
        minWidth: 500
    },
    tableWrapper: {
        overflowX: "auto"
    },
    noWrap: {
        whiteSpace: "nowrap"
    },
    iconHover: {
        '&:hover': {
            color: "rgb(61,30,144)",
            cursor: "pointer"
        }
    }
});


function Libro(props) {
    const { classes } = props;
    const cliente = useFormInput('', 'Cliente')
    const tipoOperacion = useFormInput("", 'Tipo de Operacion')
    const tipoLibro = useFormInput("", 'Tipo de Libro')
    const tipoEnvio = useFormInput("", 'Tipo de Envio')
    const vigente = useFormInput('Vigentes', 'Vigencia')
    const ano = useFormInput(null, 'Año')
    const mes = useFormInput(null, 'Mes')
    const desde = useDateInput(moment().add(-1, 'M').format('YYYY-MM-DD'), 'Desde');
    const hasta = useDateInput(moment().add(1, 'M').format('YYYY-MM-DD'), 'Hasta');
    const [abreMenu, setAbreMenu] = useState(false);
    const [anchorMenu, setAnchorMenu] = useState(null);
    const [currentDte, setCurrentDte] = useState(-1);
    const [abreDTEs, setAbreDTEs] = useState(false);
    const [libro, setLibro] = useState(null);
    const [cargando, setCargando] = useState(-1);
    const [filasTabla, setFilasTabla] = useState({});

    const [data, setData] = useState({
        desde: desde.value,
        hasta: hasta.value
    });

    const layoutContext = useContext(LayoutContext);

    /* useEffect(() => {
        if (!layoutContext.state.libro) {
            actualizaTabla(data);
        }
    }, [layoutContext.state.libro]) */

    function actualizaTabla(d) {
        if (!cargando || cargando == -1) {
            setCargando(true)
            setData(d);
            if (d.pagnueva) {
                d.pagina = 0
                delete (d.pagnueva);
            }
            axios.post("/api/libro/listado", d)
                .then(da => {
                    da.datos = da.datos.map(o => {
                        o.tipo_libro = o.tipo_libro === null ? 3 : o.tipo_libro
                        return o;
                    })
                    setFilasTabla(da); setCargando(false)
                }).catch(e => console.error(e))
        }
    }

    function onSearch(pagnueva = false) {
        var d = {
            desde: desde.value,
            hasta: hasta.value,
            ano: ano.value,
            mes: mes.value,
            cliente: cliente.value == "" ? null : cliente.value,
            vigente: vigente.value,
            tipoOperacion: tipoOperacion.value,
            tipoLibro: tipoLibro.value,
            tipoEnvio: tipoEnvio.value
        }
        if (pagnueva) {
            d.pagnueva = true;
        }
        setData(d);
    }

    function toggleMenu(event, dte) {
        setCurrentDte(dte);
        setAnchorMenu(!abreMenu ? event.target : null);
        setAbreMenu(!abreMenu);
    }

    function cerrarMenu() {
        setAbreMenu(false);
    }

    const ITEM_HEIGHT = 48;

    const Operaciones = ["Venta", "Compra", "Boleta", "Guia de Despacho"];
    const Tipos = ["Mensual", "Especial", "Rectifica", "Resumen de Ventas Diarias"];
    const Envios = ["Total", "Parcial", "Final", "Ajuste"];

    const columns = [
        { name: "ID", key: "id_libro", options: { display: false } },
        { name: "Tipo de Libro", key: "tipo_libro", options: { customBodyRender: (value, tableMeta, updateValue) => Tipos[value || 0] } },
        { name: "Tipo de Operacion", key: "tipo_operacion", options: { customBodyRender: (value, tableMeta, updateValue) => Operaciones[value || 0] } },
        { name: "Tipo de Envio", key: "tipo_envio", options: { customBodyRender: (value, tableMeta, updateValue) => Envios[value || 0] } },
        { name: "Año Período", key: "ano_periodo" },
        { name: "Mes Período", key: "mes_periodo" },
        { name: "Fecha Creación", key: "fecha_creacion", options: { sortDirection: 'desc', customBodyRender: (value, tableMeta, updateValue) => { return moment(value).format("L") } } },
        { name: "DTEs", key: "total", options: { customBodyRender: (value, tableMeta, updateValue) => { return (value || 0).toLocaleString() } } },
        {
            name: "Estado", key: "estado", options: {
                display: !props.agregar, customBodyRender: (value, tableMeta, updateValue) => {
                    var vigente = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return <StyledBadge badgeContent={""} color={vigente ? "primary" : "secondary"}>
                        {Estado(value, () => { })}
                    </StyledBadge>
                }
            }
        },
        {
            name: "Acciones", key: "acciones", options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    var rowData = tableMeta.rowData;
                    return props.agregar ?
                        <div>
                            <Tooltip title={"Agregar a este Libro"}>
                                <IconButton onClick={(event) => {
                                    props.accionAgregar(event, rowData)
                                }
                                }>
                                    <Icon>add</Icon>
                                </IconButton>
                            </Tooltip>
                        </div>
                        :
                        <div>
                            <IconButton onClick={(event) => {
                                toggleMenu(event, rowData)
                            }
                            }>
                                <Icon>more_vert</Icon>
                            </IconButton>
                            {/* id && !externo ?
                            
                                <IconButton onClick={() => Imprimir(props.tipoDTE, [{ id_dte: id }])}>
                                    <PrintIcon />
                                </IconButton>
                            
                            : null */}
                        </div>
                },
                sort: false
            }
        },
        { name: "Vigente", key: "vigente", options: { display: false } }
    ]

    var estadoIndex = _.findIndex(columns, function (column) { return column.key == "estado" });
    var tipoIndex = _.findIndex(columns, function (column) { return column.key == "tipo_libro" });
    var totalIndex = _.findIndex(columns, function (column) { return column.key == "total" });
    var dteData = {}
    _.each(currentDte, (item, ix) => {
        dteData[columns[ix].key] = item;
    });
    return (
        <div>
            <Grid container spacing={24}>
                <Grid item xs={1}>
                    <TextField select InputLabelProps={{ shrink: true }} {...tipoLibro}>
                        <MenuItem value={""}>Todos</MenuItem>
                        <MenuItem value={"RCOF"}>Resumen de Ventas Diarias</MenuItem>
                        <MenuItem value={"ME"}>Mensual</MenuItem>
                        <MenuItem value={"ES"}>Especial</MenuItem>
                        <MenuItem value={"RE"}>Rectifica</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={1}>
                    <TextField select InputLabelProps={{ shrink: true }} {...tipoOperacion}>
                        <MenuItem value={""}>Todos</MenuItem>
                        <MenuItem value={"VE"}>Venta</MenuItem>
                        <MenuItem value={"CO"}>Compra</MenuItem>
                        <MenuItem value={"BO"}>Boleta</MenuItem>
                        <MenuItem value={"GD"}>Guía de Despacho</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={1}>
                    <TextField select InputLabelProps={{ shrink: true }} {...tipoEnvio}>
                        <MenuItem value={""}>Todos</MenuItem>
                        <MenuItem value={"TO"}>Total</MenuItem>
                        <MenuItem value={"PA"}>Parcial</MenuItem>
                        <MenuItem value={"FI"}>Final</MenuItem>
                        <MenuItem value={"AJ"}>Ajuste</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={1}>
                    <TextField {...ano} />
                </Grid>
                <Grid item xs={1}>
                    <TextField {...mes} />
                </Grid>
                <Grid item xs={2}>
                    <TextField {...desde} />
                </Grid>
                <Grid item xs={2}>
                    <TextField {...hasta} />
                </Grid>
                <Grid item xs={1}>
                    <TextField select InputLabelProps={{ shrink: true }} {...vigente}>
                        <MenuItem value={"Todos"}>Todos</MenuItem>
                        <MenuItem value={"Vigentes"} defaultChecked>Vigentes</MenuItem>
                        <MenuItem value={"NoVigentes"}>No Vigentes</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={1}>
                    <IconButton color="primary" className={classes.button} aria-label="search" onClick={e => { e.preventDefault(); onSearch(true) }}>
                        <Icon>search</Icon>
                    </IconButton>
                    {/* <IconButton color="primary" className={classes.button} aria-label="clear" onClick={onCancelSearch}>
                        <Icon>clear</Icon>
                    </IconButton>
                    <IconButton color="primary" className={classes.button} aria-label="download">
                        <Icon>get_app</Icon>
                    </IconButton> */}
                </Grid>
                <Menu
                    id={"menu-descargar"}
                    anchorEl={anchorMenu}
                    open={abreMenu}
                    onClose={cerrarMenu}
                    disableAutoFocusItem={true}
                    PaperProps={{
                        style: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: 200,
                        },
                    }}>
                    <div>
                        {currentDte[totalIndex] &&
                            <MenuItem onClick={(evt) => { setAbreDTEs(true); cerrarMenu(); }}>
                                Listado de Documentos
                        </MenuItem>}
                        {
                            ((currentDte[estadoIndex] == "Creado" || currentDte[estadoIndex] == "Borrador") && currentDte[tipoIndex] != "Resumen de Ventas Diarias") &&
                            <div>
                                {currentDte[totalIndex] &&
                                    <MenuItem onClick={(evt) => {
                                        evt.preventDefault();
                                        var conf = window.confirm("¿Está seguro de querer enviar este Libro?");
                                        if (conf) {
                                            axios.post(`/api/libro/enviar`, [currentDte[0]])
                                                .then(o => { alert("Libro enviado exitosamente"); actualizaTabla(data) })
                                                .catch(e => /*alert(e.response.data.Mensaje)*/{})
                                                .finally(() => cerrarMenu())
                                        }
                                    }
                                    }>
                                        Enviar Libro
                                        </MenuItem>
                                }
                                <MenuItem onClick={(evt) => {
                                    evt.preventDefault();
                                    var conf = window.confirm("¿Está seguro de querer eliminar este Libro?");
                                    if (conf) {
                                        axios.post(`/api/libro/${currentDte[0]}/eliminar`, {})
                                            .then(o => { alert("Libro eliminado exitosamente"); actualizaTabla(data) })
                                            .catch(e => /*alert(e.response.data.Mensaje)*/{})
                                            .finally(() => cerrarMenu())
                                    }
                                }
                                }>
                                    Eliminar Libro
                                    </MenuItem>
                            </div>
                        }
                    </div>
                </Menu>
            </Grid>
            <RemoteTable columns={columns} url={"/api/libro/listado"} selection={!props.agregar} query={actualizaTabla} contenido={filasTabla} data={data} method="post" title={props.titulo} CustomToolBar={!props.agregar && ParentCustomToolbarSelect(props)} CustomFooter={CustomFooter} download={!props.agregar}></RemoteTable>
            <ModalDTEs estado={currentDte[estadoIndex]} abrir={abreDTEs} Libro={currentDte[0]} cerrar={() => { setAbreDTEs(!abreDTEs) }} />
        </div>
    );
}


function useFormInput(initialValue, label) {
    const [value, setValue] = useState(initialValue);

    function handleChange(e) {
        setValue(e.target.value)
    }

    return {
        label,
        fullWidth: true,
        value,
        onChange: handleChange
    };
}

function useDateInput(initialValue, label) {
    const [value, setValue] = useState(initialValue);

    function handleChange(e) {
        setValue(e.target.value)
    }

    return {
        label,
        fullWidth: true,
        type: "date",
        defaultValue: initialValue,
        value,
        onChange: handleChange,
        InputLabelProps: {
            shrink: true,
        }

    };
}

Libro.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Libro);


const defaultToolbarSelectStyles = {
    iconButton: {
        marginRight: "24px"
    }
};

function ParentCustomToolbarSelect(parentProps) {
    function CustomToolbarSelect(props) {

        const { classes } = props;

        /* if (props.selectedRows.length == props.selectedRows.reduce((a, e) => a + (e.data[11].props.title.toLowerCase().includes("otro sistema") ? 1 : 0), 0)) {
            return null;
        } */
        return (
            <div className={"custom-toolbar-select"}>
                {/* <Tooltip title={"Imprimir"}>
                    <IconButton className={classes.iconButton} onClick={handleClick}>
                        <PrintIcon />
                    </IconButton>
                </Tooltip> */}
                {/* <Tooltip title={"Descargar XML"}>
                    <IconButton className={classes.iconButton} onClick={handleClickXMLMasivo}>
                        <Code/>
                    </IconButton>
                </Tooltip> */}
            </div>
        );

    }
    var CustomToolBar = withStyles(defaultToolbarSelectStyles, {
        name: "CustomToolbarSelect"
    })(CustomToolbarSelect);
    return CustomToolBar;
}

function CustomFooter(count, page, rowsPerPage, changeRowsPerPage, changePage) {
    return <TablePagination
        rowsPerPageOptions={[25, 50, 100]}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        labelRowsPerPage="Filas por página"
        backIconButtonProps={{
            'aria-label': 'Página anterior',
        }}
        nextIconButtonProps={{
            'aria-label': 'Página siguiente',
        }}
        onChangePage={(evt, page) => { changePage(page) }}
        onChangeRowsPerPage={(evt) => { changeRowsPerPage(evt.target.value) }}
    />
}